<template>
    <div v-if="visible || visibleWfsT">
        <pre v-if="$store.getters.showDevInfo">
test {{ step }} {{ contentTypeId }} {{ editData }}</pre
        >
        <feedback-selection-panel
            v-if="step === FEEDBACKS_STEPS.CHOOSE_LAYER"
            :contentTypeId="contentTypeId"
            :feedbackId="feedbackId"
            :feedbackOptions="feedbackOptions"
            @cancel="$_onCancel()"
            @selected="$_onSelectLayer($event)"
        />
        <feedback-draw
            v-else-if="step === FEEDBACKS_STEPS.DRAW"
            :contentTypeId="contentTypeId"
            :feedbackId="feedbackId"
            :isEditing="isEditing"
            :feedbackObject="feedbackObject"
            :originalFeedbackGeometryType="originalFeedbackGeometryType"
            :geometryTypeChoice="geometryTypeChoice"
            :feedbackType="type"
            :layerId="layerId"
            @cancel="$_onCancel()"
            @finished="$_onDrawnPoints($event)"
        />
        <feedback-delete-panel
            v-else-if="step === FEEDBACKS_STEPS.DELETE"
            :deletefeedbacks="editData"
            @finished="$_onFinished"
            @cancel="$_onCancel()"
        />
        <template v-if="changeshape || step === FEEDBACKS_STEPS.EDIT">
            <feedback-edit-panel
                v-show="step === FEEDBACKS_STEPS.EDIT"
                :feedbackId="feedbackId"
                :feedbackObject="feedbackObject"
                :isEditing="isEditing"
                @finished="$_onFinished"
                @cancel="$_onCancel()"
                @setLocation="$_setLocation($event)"
            />
        </template>
        <template v-if="changeshape || step === FEEDBACKS_STEPS.WFST_EDIT">
            <wfst-edit-panel
                v-show="step === FEEDBACKS_STEPS.WFST_EDIT"
                :layerId="feedbackId"
                :themeLayerId="layerId"
                :layerObject="feedbackObject"
                :isEditing="isEditingWfsT"
                @finished="$_onFinished"
                @cancel="$_onCancel()"
                @setLocation="$_setLocation($event)"
            />
        </template>
    </div>
</template>

<script>
    import { mapActions, mapState, mapGetters, mapMutations } from 'vuex';
    import {
        CONTENT_TYPE_ID,
        FEEDBACKS_STEPS,
        INTERFACE_PANEL_TRIGGERS,
        GPS_MARKER_TYPE,
        NG_LAYER_TYPES
    } from '../../../../constants';
    import FeedbackSelectionPanel from './FeedbackSelection.vue';
    import FeedbackEditPanel from './FeedbackEdit.vue';
    import FeedbackDeletePanel from './FeedbackDelete.vue';
    import FeedbackDraw from '../../feedbacks/FeedbackDraw.vue';
    import WfsTEditPanel from '../layers/WfsTEdit.vue';

    import { getLocationString } from '../../../../services/feedback';

    export default {
        props: { feedbackType: { type: String, default: 'feedback' } },
        components: {
            'feedback-selection-panel': FeedbackSelectionPanel,
            'feedback-edit-panel': FeedbackEditPanel,
            'feedback-delete-panel': FeedbackDeletePanel,
            'feedback-draw': FeedbackDraw,
            'wfst-edit-panel': WfsTEditPanel
        },

        data() {
            return {
                contentTypeConst: CONTENT_TYPE_ID,
                FEEDBACKS_STEPS: FEEDBACKS_STEPS,
                // the id of the 'theme'
                feedbackId: null,
                layerId: null,
                // the data of the feedback instance, not the 'theme'
                feedbackData: null,
                step: null,
                type: null,
                feedbackObject: null,
                deletefeedbacks: null,
                changeshape: false,
                originalFeedbackGeometryType: null
            };
        },

        computed: {
            ...mapState(['uiElements', 'context']),
            ...mapGetters([
                'isMobile',
                'getMainMap',
                'getWebTheme',
                'getEditableFeedbacksByContentTypeId',
                'getActivatedLayers'
            ]),
            feedbackPanel: function () {
                return this.uiElements[INTERFACE_PANEL_TRIGGERS.FEEDBACK_EDIT];
            },
            wfsTPanel: function () {
                return this.uiElements[INTERFACE_PANEL_TRIGGERS.WFS_T_EDIT];
            },
            visible: function () {
                return this.feedbackPanel.visible;
            },
            visibleWfsT: function () {
                return this.wfsTPanel?.visible;
            },
            editData: function () {
                return this.feedbackPanel.data;
            },
            isEditing: function () {
                return !!this.editData;
            },
            editDataWfsT: function () {
                return this.wfsTPanel.data;
            },
            isEditingWfsT: function () {
                return !!this.editDataWfsT;
            },
            mode: function () {
                return this.feedbackPanel.mode;
            },
            contentTypeId: function () {
                return this.feedbackPanel.contentTypeId;
            },
            geometryTypeChoice: function () {
                return this.feedbackPanel.geometryTypeChoice;
            },
            feedbackOptions() {
                return this.getEditableFeedbacksByContentTypeId(this.contentTypeId);
            },
            defaultFeedback() {
                return this.feedbackOptions.length === 1
                    ? this.feedbackOptions[0].value
                    : null;
            }
        },
        watch: {
            step(newVal) {
                this.$_changeGpsIcon();
            },

            visible(newVal) {
                this.type = NG_LAYER_TYPES.FEEDBACK;
                this.feedbackObject = null;
                this.MARKING_SELECTION_AREA(newVal);
                if (this.context === 'web' && this.mode !== 'delete') {
                    this.feedbackId = this.$store.state.feedbacks[0]?.id;
                    this.step = FEEDBACKS_STEPS.DRAW;
                    this.$_changeGpsIcon();
                    return;
                }

                if (newVal && this.defaultFeedback && !this.isEditing) {
                    this.$_onSelectLayer(this.defaultFeedback);
                    return;
                }

                this.originalFeedbackGeometryType = null;
                this.step = FEEDBACKS_STEPS.CHOOSE_LAYER;
                this.feedbackId = null;
                if (newVal === true) {
                    this.TOGGLE_OBJECT_DETAIL_PANEL(false);
                    if (this.mode === 'delete' && this.editData) {
                        // delete existing feedback object
                        this.step = FEEDBACKS_STEPS.DELETE;
                    } else if (this.isEditing) {
                        if (this.editData.features != null) {
                            // editing selection of feedback objects
                            this.feedbackId = this.editData.layer.data.feedbackId;
                            const featureProperties =
                                this.editData.features[0].getProperties();
                            const geometryType = this.editData.features[0]
                                .getGeometry()
                                .getType();

                            this.originalFeedbackGeometryType = geometryType;

                            let feature = this.editData.features[0];
                            this.feedbackObject = {
                                featureObject: {
                                    feature,
                                    features: this.editData.features,
                                    geometryType,
                                    location: null
                                },
                                measureTotals: {
                                    area: featureProperties.area,
                                    coord_x: featureProperties.coord_x,
                                    coord_y: featureProperties.coord_y,
                                    length: featureProperties.length
                                },
                                data: featureProperties
                            };
                        } else {
                            // editing one feedback object
                            this.$_setfeedback();
                        }
                        this.step = FEEDBACKS_STEPS.EDIT;
                    }
                }
            },
            visibleWfsT(newVal) {
                this.type = NG_LAYER_TYPES.THEME;
                this.feedbackObject = null;
                this.MARKING_SELECTION_AREA(newVal);
                if (this.context === 'web' && this.mode !== 'delete') {
                    this.feedbackId = this.$store.state.feedbacks[0]?.id;
                    this.step = FEEDBACKS_STEPS.DRAW;
                    this.$_changeGpsIcon();
                    return;
                }

                if (newVal && this.defaultFeedback && !this.isEditingWfsT) {
                    this.$_onSelectLayer(this.defaultFeedback);
                    return;
                }

                this.originalFeedbackGeometryType = null;
                this.step = FEEDBACKS_STEPS.CHOOSE_LAYER;
                this.feedbackId = null;
                if (newVal === true) {
                    this.TOGGLE_OBJECT_DETAIL_PANEL(false);
                    // At the moment it is nog possible to add or delete an WfsT object
                    // So this if-statement is just for later
                    if (this.mode === 'delete' && this.editDataWfsT) {
                        // delete selected wfs-t object
                        this.step = FEEDBACKS_STEPS.DELETE;
                    } else if (this.isEditingWfsT) {
                        // edit a selected wfs-t object
                        this.$_setWfsT();
                        this.step = FEEDBACKS_STEPS.WFST_EDIT;
                    }
                }
            }
        },
        methods: {
            ...mapActions(['togglePanel']),
            ...mapMutations([
                'MARKING_SELECTION_AREA',
                'TOGGLE_OBJECT_DETAIL_PANEL',
                'SET_DRAW_GEOMETRYTYPE_DEFAULT'
            ]),
            $_onFinished() {
                if (
                    this.isMobile &&
                    this.contentTypeId === CONTENT_TYPE_ID.FEEDBACK &&
                    !this.isEditing &&
                    this.mode !== 'delete'
                ) {
                    this.step = FEEDBACKS_STEPS.DRAW;
                } else {
                    this.$_finished();
                }
            },
            $_onCancel() {
                this.$_close();
            },
            $_finished() {
                if (this.isMobile) {
                    this.$store.dispatch('refreshSelection');
                } else {
                    this.$store.dispatch('refreshWebFeedback', { mapName: null });
                }
                this.$_close();
            },
            $_close() {
                this.changeshape = false;
                if (this.$store.getters.isMobile) {
                    if (this.type === NG_LAYER_TYPES.THEME) {
                        this.SET_DRAW_GEOMETRYTYPE_DEFAULT({
                            panel: INTERFACE_PANEL_TRIGGERS.WFS_T_EDIT,
                            geometryType: null
                        });
                        this.togglePanel({
                            panelName: INTERFACE_PANEL_TRIGGERS.CLOSE_WFS_T,
                            visible: false
                        });
                    } else {
                        this.SET_DRAW_GEOMETRYTYPE_DEFAULT({
                            panel: INTERFACE_PANEL_TRIGGERS.FEEDBACK_EDIT,
                            geometryType: null
                        });
                    }
                }
                // close feedback panel
                this.togglePanel({
                    panelName: INTERFACE_PANEL_TRIGGERS.CLOSE_FEEDBACK,
                    visible: false
                });
            },
            $_onSelectLayer(feedbackId) {
                const layer = this.feedbackOptions.find(
                    (f) => f.value === feedbackId
                );
                this.feedbackId = feedbackId;
                // extra info voor WFS-T layer
                if (layer !== null) {
                    this.type = layer.type;
                    this.layerId = layer.layerId;
                }
                this.step = FEEDBACKS_STEPS.DRAW;
            },
            $_onDrawnPoints(feedbackObject) {
                this.step =
                    this.type === NG_LAYER_TYPES.THEME
                        ? FEEDBACKS_STEPS.WFST_EDIT
                        : FEEDBACKS_STEPS.EDIT;
                this.feedbackObject = {
                    ...this.feedbackObject,
                    ...feedbackObject,
                    updated: true
                };
                this.changeshape = false;
            },
            $_setLocation(locationObject) {
                this.$store.commit('SET_ALERT_MESSAGE', {
                    message: locationObject.statusMessage,
                    alertClass: 'lower',
                    variant: 'info',
                    optional: false,
                    hasSearch: false
                });
                // hide message with delay
                setTimeout(() => {
                    this.$store.commit('SET_ALERT_MESSAGE', {
                        message: null,
                        alertclass: null,
                        variant: null,
                        optional: null,
                        hassearch: null
                    });
                }, 5000);
                this.feedbackObject.editFeedbackFields =
                    locationObject.editFeedbackFields;
                this.changeshape = true;
                this.step = FEEDBACKS_STEPS.DRAW;
            },
            $_changeGpsIcon() {
                if (this.visible) {
                    if (this.step === FEEDBACKS_STEPS.DRAW) {
                        this.$store.commit('MARKER_GPS_CHANGE_ICON', {
                            mapName: 'main',
                            typeMarker: GPS_MARKER_TYPE.Rose
                        });
                    }
                } else {
                    this.$store.commit('MARKER_GPS_CHANGE_ICON', {
                        mapName: 'main',
                        typeMarker: GPS_MARKER_TYPE.Default
                    });
                }
            },
            $_setfeedback() {
                // the user wants to change just one feedback
                this.feedbackId = this.editData.layer.data.feedbackId;
                const featureProperties = this.editData.feature.getProperties();
                const geometryType = this.editData.feature.getGeometry().getType();
                const location = getLocationString(this.editData.feature);
                this.originalFeedbackGeometryType = geometryType;

                this.feedbackObject = {
                    featureObject: {
                        feature: this.editData.feature,
                        features: null,
                        geometryType,
                        location
                    },
                    measureTotals: {
                        area: featureProperties.area,
                        coord_x: featureProperties.coord_x,
                        coord_y: featureProperties.coord_y,
                        length: featureProperties.length
                    },
                    data: featureProperties
                };
            },
            $_setWfsT() {
                this.feedbackId = this.editDataWfsT.layer.data.id;
                this.layerId = this.editDataWfsT.layer.data.customId;
                const featureProperties = this.editDataWfsT.feature.getProperties();
                const geometryType = this.editDataWfsT.feature
                    .getGeometry()
                    .getType();
                const location = getLocationString(this.editDataWfsT.feature);
                this.originalFeedbackGeometryType = geometryType;

                this.feedbackObject = {
                    featureObject: {
                        feature: this.editDataWfsT.feature,
                        features: null,
                        geometryType,
                        location
                    },
                    data: featureProperties
                };
            }
        }
    };
</script>

<style lang="scss" scoped>
pre {
    position: fixed;
    top: 20%;
    left: 20%;
    background: white;
}
</style>
